export class MontantAnnuel {

  public montantMiniAnnuel: number;

  public devise: string;

  public montantMaxiAnnuel: number;

  constructor() {
    this.montantMiniAnnuel = 0;
    this.devise = '';
    this.montantMaxiAnnuel = 0;

  }
}
